import { render } from "./TopMenuItem.vue?vue&type=template&id=d668451e"
import script from "./TopMenuItem.vue?vue&type=script&lang=js"
export * from "./TopMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/documedias/gitlab/virtuell/ispad2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__